namespace $.$$ {

	$mol_style_define( $shm_wordstat_filter_section, {
		Title: {
			display: 'grid',
			gridTemplateColumns: 'auto minmax(0, 1fr)',
			alignItems: 'center',
			font: {
				weight: 'bold',
				size: '16px',
			},
		},

		Label: {
			display: 'flex',
			alignItems: 'center',
			gap: '8px',
			minWidth: 0,
			whiteSpace: 'nowrap',
		},

		Expand: {
			margin: {
				left: '-0.5rem',
			},
		},
	} )

}
